import { Box, SegmentedProgressBar, Skeleton } from "@prismicio/editor-ui"

interface UsageProgressBarProps {
  quota?: number
  limit: number
  totalUsage: number
}

export function UsageProgressBar(props: UsageProgressBarProps) {
  const { quota, limit, totalUsage } = props
  return (
    <SegmentedProgressBar
      threshold={quota}
      max={limit}
      value={totalUsage}
      belowThresholdLabel="Included quota"
      aboveThresholdLabel="Allowed overage"
    />
  )
}

export function UsageProgressBarSkeleton() {
  return (
    <Box gap={16} alignItems="center" flexDirection="column">
      <Skeleton width="100%" height={16} color="green4" />
      <Skeleton width={120} height={16} color="grey5" />
    </Box>
  )
}
